import { Directive } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';

export const YEAR_FORMAT = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Directive({
  selector: '[appYearDateFormat]',
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: YEAR_FORMAT},
  ],
})

export class YearDateFormatDirective {

  constructor() { }

}
